
import axios from "axios";
export const API_BASE_URL = "https://wgr.mwsgkp.in";


export const monthNames = [
  "",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];



export const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.clear();
      window.location.replace("/login");
    }

    return Promise.reject(error);
  }
);





export const PDFCOLORSHEME = {
  FONT_SIZE_HEADING: 20,

  FONT_SIZE_BODY: 9,
  BODY_TEXT_COLOR:"#000",


  BACK_COLOR_GROUP: "#0a0458",
  FONT_COLOR_GROUP: "#fff",
  FONT_SIZE_GROUP: 9,



   BACK_COLOR_GROUP1: "#951807",
  FONT_COLOR_GROUP1: "#fff",
  FONT_SIZE_GROUP1: 9,



  BACK_COLOR_HEADER: "#1329ec",
  FONT_COLOR_HEADER: "#fff",
  FONT_SIZE_HEADER: 9,


  BACK_COLOR_TOTAL: "#e9490a",
  FONT_COLOR_TOTAL: "#fff",
  FONT_SIZE_TOTAL: 9,

  BACK_COLOR_GRAND_TOTAL: "#077e35",
  FONT_COLOR_GRAND_TOTAL: "#fff",
  FONT_SIZE_GRAND_TOTAL: 9,


  BACK_COLOR_SUMMERY_HEADING: "#fc0e91",
  FONT_COLOR_SUMMERY_HEADING: "#faf6f6",
  FONT_SIZE_SUMMERY_HEADING: 9,


BACK_COLOR_SUMMERY_HEADING1: "#6c6603",
FONT_COLOR_SUMMERY_HEADING1: "#faf6f6",
  FONT_SIZE_SUMMERY_HEADING1: 9,


  PRIMARY: "#1976D2",
  SECONDARY: "#424242",
  HEADER_BG: "#E3F2FD",
  HEADER_TEXT: "#000000",
  BORDER: "#000",



};

export const PDF_TABLE_STYLE = {
  theme: "plain",

  bodyStyles: {
    lineWidth: 0.3,
  },
};